import { currencyInCentsFormatter } from '@/utils/currencies';

export const getInsuranceFinanceFormatted = ({
  currencyToFormat,
  suffix,
  currencyFormatter = currencyInCentsFormatter
}: {
  currencyToFormat?: number | null;
  suffix?: string;
  currencyFormatter?: (currency: number) => string;
}) => {
  return currencyToFormat || currencyToFormat === 0
    ? currencyFormatter(currencyToFormat) + (suffix ? ` ${suffix}` : '')
    : '-';
};
